import React, { useState } from 'react'
import { Minus, Plus } from 'react-feather'
import styled, { css } from 'styled-components'

import { MEDIA_QUERY_DESKTOP } from '../utils/media-query'

const Component = styled.div``

const QuestionTitle = styled.h4`
  font-size: 1.25rem;
  flex-grow: 1;
`

const QuestionIcon = styled.div`
  display: flex;
  align-self: center;
  justify-content: center;
`

const QuestionContent = styled.div`
  margin-top: 1rem;
  color: rgba(255, 255, 255, .5);
`

const QuestionHeader = styled.div`
  display: flex;
  align-self: center;
  justify-content: center;
  user-select: none;
`

const Question = styled.div`
  padding: 1rem 0;
  max-width: 620px;
  border-bottom: 1px solid rgba(255, 255, 255, .15);
  cursor: pointer;

  strong {
    color: white;
  }

  ${MEDIA_QUERY_DESKTOP} {
    padding: 1.5rem 0;
  }

  &:last-child {
    border-bottom: 0;
  }

  ${props => {
    if (props.$isOpen) {
      return css`
        `
    }
  }}
`

const getInitialOpenQuestions = questions => {
  return questions.reduce((acc, question, index) => {
    if (question?.isOpen === true) {
      acc.push(index)
    }

    return acc
  }, [])
}

const QuestionList = ({ questions }) => {
  const [openQuestions, setOpenQuestions] = useState(getInitialOpenQuestions(questions))

  const handleClickHeader = index => () => {
    const isOpen = openQuestions.includes(index)

    const newOpenSections = isOpen
      ? openQuestions.filter(i => i !== index)
      : [
          ...openQuestions,
          index
        ]

    setOpenQuestions(newOpenSections)
  }

  return (
    <Component>
      {questions.map((q, index) => {
        const isOpen = openQuestions.includes(index)

        return (
          <Question
            key={index}
            $isOpen={isOpen}
          >
            <QuestionHeader onClick={handleClickHeader(index)}>
              <QuestionTitle>
                {q.title}
              </QuestionTitle>
              <QuestionIcon>
                {isOpen ? (
                  <Minus />
                ) : (
                  <Plus />
                )}
              </QuestionIcon>
            </QuestionHeader>
            {isOpen && (
              <QuestionContent>
                {q.content}
              </QuestionContent>
            )}
          </Question>
        )
      })}
    </Component>
  )
}

export default QuestionList
